module.exports = __webpack_public_path__ + "static/media/app-image.d3e96ed4.png";